
  import { Component, Ref, Vue } from 'vue-property-decorator';
  import { Action } from 'vuex-class';

  import Generic from '../../types/app/generic/generic';
  import Endpoint from '../../utils/endpoint';

  @Component({})
  export default class TaxType extends Vue {
    endpoint = new Endpoint();
    @Action('setSnackbar', { namespace: 'app' }) setSnackbar!: any;

    valid = null;
    saving = false;
    loading = false;
    rules = [v => !!v || 'This field is required'];
    isCreate = true;

    taxType: Generic = {
      name: '',
      shortName: '',
      active: true
    };

    async created() {
      this.isCreate = !this.$route.params.id;
      if (!this.isCreate) {
        this.loading = true;
        await this.getTaxType();
      }
    }

    get title(): string {
      return this.isCreate ? 'Create Tax Type' : 'Tax Type Detail';
    }

    async getTaxType(): Promise<void> {
      this.loading = true;
      const response = await this.$http.get(`${this.endpoint.taxType.getById}/${this.$route.params.id}`);

      if (response.status == 200) {
        this.taxType = response.data.data;
        this.loading = false;
      }
    }

    async save(): Promise<void> {
      if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
        if (this.isCreate) {
          await this.create();
        } else {
          await this.update();
        }
      }
    }

    async update(): Promise<void> {
      this.saving = true;

      const response = await this.$http.put(`${this.endpoint.taxType.update}/${this.$route.params.id}`, this.taxType);

      if (response.status == 200) {
        this.saving = false;

        this.setSnackbar({
          show: true,
          message: 'Tax Type update',
          color: 'success'
        });

        this.$router.push({ name: 'IndexTaxType' });
      } else {
        this.saving = false;
        console.log('erro...', response);
      }
    }

    async create(): Promise<void> {
      this.saving = true;

      const response = await this.$http.post(this.endpoint.taxType.create, this.taxType);

      if (response.status == 200) {
        this.saving = false;

        this.setSnackbar({
          show: true,
          message: 'Tax Type saved',
          color: 'success'
        });

        this.$router.push({ name: 'IndexTaxType' });
      }

      if (response.status != 200) {
        this.saving = false;
      }
    }
  }
